import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  selectUser,
  selectRoles,
} from "../../../store/authSlice";
import Sidebar from "../Sidebar/Sidebar";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import { Tooltip } from "react-tooltip";
import { heyhireBlackIcon } from "../../../assets/images";

function DashboardLayout({ children, className, notification = false }) {
  const roles = useSelector(selectRoles);
  const user = useSelector(selectUser);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const role = roles.length > 0 ? roles[0] : "";

  useEffect(() => {
    const handleResize = () => {
      // On desktop (lg and above), sidebar should be open by default
      if (window.innerWidth >= 1024) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className="w-full h-full min-h-screen bg-gray-50 overflow-x-hidden">
        {user?.id === 1 && role === "super-user" && (
          <div className="flex h-full min-h-screen overflow-x-hidden">
            {/* Sidebar */}
            <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col min-h-screen lg:pl-64 overflow-x-hidden w-0 min-w-0">
              {/* Mobile Header Bar */}
              <div className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-white border-b border-gray-200 shadow-sm">
                <div className="flex items-center justify-between px-4 h-16">
                  {/* Hamburger Menu Button */}
                  <button
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    className="p-2 rounded-lg text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-500 transition-all duration-200"
                    aria-label="Toggle sidebar"
                  >
                    <i className="fas fa-bars text-xl" />
                  </button>

                  {/* Logo */}
                  <Link to="/dashboard" className="flex items-center flex-1 justify-center">
                    <img
                      className="h-8 w-auto"
                      src={heyhireBlackIcon}
                      alt="HeyHire"
                    />
                  </Link>

                  {/* Right side spacer to balance hamburger */}
                  <div className="w-10" />
                </div>
              </div>

              {/* Main Content */}
              <main className="flex-1 pb-8 px-3 sm:px-4 md:px-6 lg:px-8 xl:px-12 overflow-x-hidden bg-gray-50 pt-20 lg:pt-8 w-full">
                <div id="page-content" className="max-w-7xl mx-auto w-full">
                  <BreadCrumb />
                  <div className="mt-6 w-full">
                    {children}
                  </div>
                </div>
              </main>
            </div>
          </div>
        )}
      </div>
      <Tooltip id={`sidebar-id`} style={{ zIndex: 9999 }} />
    </>
  );
}

export default DashboardLayout;
